import { useState, useEffect, createContext, useContext } from 'react';
import { subscribeToAuthChanges } from '../../services/authService';
import LoginPage from './LoginPage';
import './MealPrep.css';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within PrivatePortal');
  }
  return context;
};

function PrivatePortal({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeToAuthChanges((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="mp-portal">
        <div className="mp-portal-loading">
          <div className="mp-portal-loading-spinner" />
          <p>Loading</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
}

export default PrivatePortal;
